import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../sport/sport.css';
import { useUser } from '../context/UserContext';
import { hasPrivilege } from '../utils/hasPrivilege';
import Swal from 'sweetalert2';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';
const SportList = () => {
    const { userData } = useUser();
    const [searchTerm, setSearchTerm] = useState('');
    const [sports, setSports] = useState([]);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const token = localStorage.getItem('auth-token');
    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const refreshData = () => {
        setLoading(true);
        setError('');

        fetch(process.env.REACT_APP_API_ADMIN_SPORTS, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    const formattedSports = data.data.sports.map((sport) => ({
                        id: sport.id || '-',
                        name: sport.name || '-',
                        description: sport.description || '-',
                        area: sport.playingAreaName || '-',
                        bookingAllowed: sport.allowEntireCourtBooking || '-',
                        proficiencies: sport.proficiencies.join(', ') || '-',
                        enabled: sport.enabled || '-',
                        createdAt: sport.createdAt || '-',
                        updatedAt: sport.updatedAt || '-',
                        image: sport.image || '-',
                        courtBookingNotes: sport.courtBookingNotes || '-',
                        requestAllowed: sport.requestAllowed || '-',
                        isRegistrationFees: sport.isRegistrationFees || '-',
                        registrationFees: sport.registrationFees || '-',
                        renewalFees: sport.renewalFees || '-',
                        imageUrl: sport.imageUrl || '-',
                    }));
                    setSports(formattedSports);
                } else {
                    setError('Failed to load data');
                }
            })
            .catch(() => {
                setError('Failed to load data');
            })
            .finally(() => {
                setLoading(false);
            });
    };
    useEffect(() => {
        refreshData();
    }, []);
    const headers = [
        { label: "Sport Name", key: "name" },
        { label: "Description", key: "description" },
        { label: "Playing Area", key: "area" },
        { label: "Entire Court Booking Allowed?", key: "bookingAllowed" },
        { label: "Proficiencies", key: "proficiencies" },
    ];
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedSport, setSelectedSport] = useState(null);
    const [action, setAction] = useState('');
    const [formData, setFormData] = useState({ name: '', description: '', area: '', bookingAllowed: '', proficiencies: '' });
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(null);
    const dropdownRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };

    const handleCreateSport = (event) => {
        const url = `/newsport`;
        if (event.metaKey || event.ctrlKey) {
          window.open(url, "_blank");
        } else {
          navigate(url);
        }
    };

    const handleEditSport = (event, sportId) => {
        const url = `/newsport?sportId=${sportId}&action=edit`;
      
        if (event.metaKey || event.ctrlKey) {
          window.open(url, "_blank");
        } else {
          navigate(url);
        }
      };
      

    const handleDeleteSport = (sportId) => {
        Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                confirmDelete(sportId);
            }
        });
    };

    const confirmDelete = (sportId) => {
        fetch(`${process.env.REACT_APP_API_ADMIN_DELETE_SPORT}/${sportId}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        })
        .then(async (response) => {
            const result = await response.json();
    
            if (!result.success) {
                throw new Error(result.data?.message || result.success_message || 'Unknown error occurred');
            }
    
            return result;
        })
        .then(() => {
            setSports(sports.filter(sport => sport.id !== sportId));
            Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: 'Sport deleted successfully!',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
            });
        })
        .catch(error => {
            Swal.fire({
                icon: 'error',
                title: 'Oops!',
                text: error.message,
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000,
            });
        });
    };
    

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const filteredSports = sports.filter((sport) => {
        const bookingAllowedText = sport.bookingAllowed ? 'yes' : 'no';
        return Object.values(sport)
            .concat(bookingAllowedText)
            .join(' ')
            .toLowerCase()
            .includes(searchTerm.toLowerCase());
    });
    const totalPages = Math.ceil(filteredSports.length / itemsPerPage);
    const [sortConfig, setSortConfig] = useState({
        key: "name",
        direction: "ascending",
    });

    const handleSort = (columnKey) => {
        let direction = "ascending";
        if (sortConfig.key === columnKey && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key: columnKey, direction });
    };

    const sortData = (data) => {
        const { key, direction } = sortConfig;
        return [...data].sort((a, b) => {
            let aValue = a[key];
            let bValue = b[key];


            if (key === 'bookingAllowed') {
                aValue = aValue ? 1 : 0;
                bValue = bValue ? 1 : 0;
            }


            if (aValue === undefined || aValue === null) aValue = '';
            if (bValue === undefined || bValue === null) bValue = '';

            if (typeof aValue === 'string' && typeof bValue === 'string') {
                aValue = aValue.toLowerCase();
                bValue = bValue.toLowerCase();
            }

            if (aValue < bValue) return direction === "ascending" ? -1 : 1;
            if (aValue > bValue) return direction === "ascending" ? 1 : -1;
            return 0;
        });
    };


    const sortedData = sortData(filteredSports);

    const paginatedSports = sortedData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });

    const toggleDropdown = (sportId, e) => {
        e.stopPropagation();
        if (dropdownOpen === sportId) {
            return setDropdownOpen(null);
        }
        const { bottom, left } = e.currentTarget.getBoundingClientRect();
        setDropdownPos({
            top: bottom + window.scrollY,
            left: left + window.scrollX,
        });
        setDropdownOpen(sportId);
    };
    useEffect(() => {
        const closeOnScroll = () => setDropdownOpen(null);

        window.addEventListener('scroll', closeOnScroll, true);
        return () => window.removeEventListener('scroll', closeOnScroll, true);
    }, []);
    const handleProgressAttribute = (event, sportId) => {
        const url = `/ProgresAttribute?sportId=${sportId}`;
        if (event.metaKey || event.ctrlKey) {
          window.open(url, "_blank");
        } else {
          navigate(url);
        }
      };
      
      const handleCategory = (event, sportId) => {
        const url = `/category?sportId=${sportId}`;
        if (event.metaKey || event.ctrlKey) {
          window.open(url, "_blank");
        } else {
          navigate(url);
        }
      };
      
      const handleBenefit = (event, sportId) => {
        const url = `/sportBenefit?sportId=${sportId}`;
        if (event.metaKey || event.ctrlKey) {
          window.open(url, "_blank");
        } else {
          navigate(url);
        }
      };
      
      const handleCourtType = (event, sportId) => {
        const url = `/courtType?sportId=${sportId}`;
        if (event.metaKey || event.ctrlKey) {
          window.open(url, "_blank");
        } else {
          navigate(url);
        }
      };
      
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(null);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const generatePageNumbers = () => {
        const pages = [];
        const totalPagesToShow = 5;

        if (totalPages <= totalPagesToShow) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            pages.push(1);
            if (currentPage > 3) pages.push('...');
            for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
                pages.push(i);
            }
            if (currentPage < totalPages - 2) pages.push('...');
            pages.push(totalPages);
        }
        return pages;
    };

    const renderPagination = () => {
        return generatePageNumbers().map((page, index) =>
            typeof page === 'number' ? (
                <button
                    key={index}
                    className={`page-number ${currentPage === page ? 'active' : ''}`}
                    onClick={() => handlePageClick(page)}
                >
                    {page}
                </button>
            ) : (
                <span key={index} className="pagination-dots">
                    {page}
                </span>
            )
        );
    };

    const totalEntries = filteredSports.length;
    const indexOfFirstEntry = (currentPage - 1) * itemsPerPage + 1;
    const indexOfLastEntry = Math.min(currentPage * itemsPerPage, totalEntries);

    return (
        <div className="enrollment-container">
            <div className="search-bar">
                <div className="input-container">
                    <input
                        type="text"
                        id="searchInput"
                        placeholder=""
                        className={`search-input ${searchTerm ? "has-value" : ""}`}
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                    <label htmlFor="searchInput" className="floating-label">
                        🔍 Search
                    </label>
                </div>


                <button
                    className="create-button-new"
                    onClick={handleCreateSport}
                >
                    <span className="create-button__icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="23"
                            height="23"
                            className="create-button__svg"
                        >
                            <path
                                d="M12 5v14M5 12h14"
                                stroke="white"
                                strokeWidth="2.3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>
                    <span className="create-button__label">
                        Create Sport
                    </span>
                </button>
            </div>

            <div className="items-and-dues">
                <select className="items-per-page-select" value={itemsPerPage} onChange={handleItemsPerPageChange}>
                    <option value={10}>10 items per page</option>
                    <option value={25}>25 items per page</option>
                    <option value={50}>50 items per page</option>
                    <option value={75}>75 items per page</option>
                </select>
                <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${itemsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
                <button className="tt-action-btn" onClick={refreshData}>
                    <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
                    Refresh
                </button>
            </div>
            {loading && (
                <div className="premium-loader">
                    <div className="progress-track">
                        <div className="progress-bar"></div>
                    </div>
                    <div className="status-text">
                        <span>L</span>
                        <span>O</span>
                        <span>A</span>
                        <span>D</span>
                        <span>I</span>
                        <span>N</span>
                        <span>G</span>
                    </div>
                </div>
            )}
            {error && <div className="error-message">{error}</div>}
            {!loading && !error && filteredSports.length === 0 && (
                <div className="error-message">No data available</div>
            )}
            <div className="payment-list-scroll-container" style={{ overflowY: 'auto' }}>
                <table className="payment-list-table">
                    <thead>
                        <tr>
                            {headers.map(({ key, label }) => (
                                <th key={key} className="challenges-column" onClick={() => handleSort(key)}>
                                    <div className="th-content">
                                        <span>{label}</span>
                                        <FiChevronDown
                                            className={`sort-icon ${sortConfig.key === key ? 'active' : ''
                                                } ${sortConfig.key === key && sortConfig.direction === 'descending' ? 'desc' : ''}`}
                                        />
                                    </div>
                                </th>
                            ))}
                            {hasPrivilege(userData, 'SPORTS', 'SPORT_LIST_MODIFY') && (<th>Action</th>)}
                        </tr>
                    </thead>

                    <tbody>
                        {paginatedSports.map((sport) => (
                            <tr key={sport.id}>
                                <td>{sport.name}</td>
                                <td>{sport.description}</td>
                                <td>{sport.area}</td>
                                <td>{sport.bookingAllowed ? 'Yes' : 'No'}</td>
                                <td>{sport.proficiencies}</td>
                                {hasPrivilege(userData, 'SPORTS', 'SPORT_LIST_MODIFY') && (
                                    <td className="sport-actions-column">
                                        <button
                                            className="action-button"
                                            type="button"
                                            onClick={(e) => toggleDropdown(sport.id, e)}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                fontSize: '24px',
                                            }}
                                        >
                                            &#x22EE;
                                        </button>

                                        {dropdownOpen === sport.id && (
                                            <div
                                                className="custom-dropdown-player"
                                                ref={dropdownRef}
                                                style={{
                                                    position: 'absolute',
                                                    top: dropdownPos.top,
                                                    left: dropdownPos.left,
                                                    zIndex: 9999,
                                                    backgroundColor: 'white',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px',
                                                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                                    minWidth: '180px',
                                                }}
                                            >
                                               <button className="dropdown-item" onClick={(e) => handleEditSport(e, sport.id)}>Edit</button>
<button className="dropdown-item" onClick={(e) => handleDeleteSport(sport.id)}>Delete</button>
<button className="dropdown-item" onClick={(e) => handleBenefit(e, sport.id)}>Sport Benefits</button>
<button className="dropdown-item" onClick={(e) => handleCourtType(e, sport.id)}>Court Type</button>
<button className="dropdown-item" onClick={(e) => handleProgressAttribute(e, sport.id)}>Progress Attribute</button>
<button className="dropdown-item" onClick={(e) => handleCategory(e, sport.id)}>Curriculum Category</button>


                                            </div>
                                        )}
                                    </td>
                                )}

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="pagination">
                <div className="showing-entries">
                    Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
                </div>
                <button
                    className="prev-button"
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                {renderPagination()}
                <button
                    className="next-button"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default SportList;
